import React from 'react';
import CriteriaButton from './CriteriaButton';
import { CriteriaKey } from '../types';

interface CriterionDef {
  key: CriteriaKey;
  label: string;
  subtitle?: string;
  isSubtitleLink?: boolean;
}

const CRITERIA: CriterionDef[] = [
  { key: 'temperature',    label: 'חום לא תקין' },
  { key: 'tachycardia',    label: 'טכיקרדיה' },
  { key: 'lowBP',          label: 'לחץ דם נמוך' },
  { key: 'consciousness',  label: 'ירידה במצב הכרה' },
  {
    key: 'capillaryRefill',
    label: 'מילוי קפילרי מאורך',
    subtitle: '3 שניות ומעלה'
  },
  { key: 'weakPulse',      label: 'דופק חלש במישוש' },
  { key: 'mottledSkin',    label: 'עור שיש או כחלון' },
  {
    key: 'riskFactor',
    label: 'גורם סיכון רפואי',
    subtitle: 'גורמי הסיכון',
    isSubtitleLink: true
  },
];

interface CriteriaGridProps {
  activeButtons: Record<CriteriaKey, boolean>;
  onToggle: (key: CriteriaKey) => void;
  onRiskInfoClick: () => void;
}

const CriteriaGrid: React.FC<CriteriaGridProps> = ({ activeButtons, onToggle, onRiskInfoClick }) => {
  return (
    <div className="criteria-grid" dir="rtl">
      {CRITERIA.map((criterion) => (
        <CriteriaButton
          key={criterion.key}
          criteriaKey={criterion.key}
          label={criterion.label}
          subtitle={criterion.subtitle}
          isSubtitleLink={criterion.isSubtitleLink}
          isActive={activeButtons[criterion.key]}
          onClick={onToggle}
          onInfoClick={criterion.key === 'riskFactor' ? onRiskInfoClick : undefined}
        />
      ))}
    </div>
  );
};

export default CriteriaGrid;
